import React, { Component, useEffect, useState, useRef, useMemo} from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-materialize";
import { connect } from "react-redux";
import classnames from "classnames";
import ReactToPrint from "react-to-print";
import MasterPackLabel from "../../components/label/masterpack"
import { toPng, toBlob } from 'html-to-image';
import { postPrintStandardZebraUsb } from "../../utils/prodlocalhelper";
import { downloadBlob, htmlLabelToBlobImage } from "../../utils/blobImageHelper";

import { withTranslation } from 'react-i18next';
import { compose } from "redux";
import cameraModelApi from "../../api/cameraModelApi";
import masterpackApi from "../../api/masterpackApi";
import twinPackApi from "../../api/twinPacks";
import cameraApi from "../../api/cameraApi";
import featureSwitchApi from "../../api/featureSwitchApi";
import { regXp, isValidMasterpackBarcode } from '../../utils/validation';
import { useAppContext } from "../../components/context/appContext";
import { useReactToPrint } from "react-to-print";

import { IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import ReactTableBuilder from "../../utils/reactTableBuilder";
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow,MuiBox, PrinterTypes } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';
import { MuiButton } from "../../components/mui";
import { isFloatLocales } from "validator";


function NewMasterpackV2(props) {
  const { t } = props;
  const [cameraModels, setCameraModels] = useState();
  const [currentModel, setCurrentModel] = useState();
  const [qtyInMasterpackBarcodes, setQtyInMasterpackBarcodes] = useState();
  const [currentQtyInMasterpack, setCurrentQtyInMasterpack] = useState();
  const [specialRemark, setSpecialRemark] = useState();
  const [scannerValue, setScannerValue] = useState();
  const [scannerError, setScannerError] = useState();
  const [currentMasterpack, setCurrentMasterpack] = useState({});
  const [tableData, setTableData] = useState([]);
  const [twinAssociateAllowed, setTwinAssociationAllowed] = useState(false);
  const [showPrintLabel, setShowPrintLabel] = useState(false);
  const [rfidActive, setRfidActive] = useState(false);
  const [rfidFlag, setRfidFlag] = useState(false);
  const [twinPacks, setTwinPacks] = useState([]);
  const [pendingTwinPack, setPendingTwinPacks] = useState([]);
  const [isLoadedMasterpack, setIsLoadedMasterpack] = useState(false);
  const [masterpackFull, setMasterpackFull] = useState(false);
  const appContext = useAppContext();

  let printContentRef = useRef(null);

  const cameraModelsOption = useMemo(() => {
    return (
      cameraModels?.map((model) => ({
        label: model.name,
        value: model.name,
      })) ?? []
    );
  }, [cameraModels]);

  const qtyInMasterpackOptions = useMemo(() => {
    return (
      qtyInMasterpackBarcodes?.map((model) => ({
        label: model.masterpackQuantity.toString(),
        value: model.masterpackQuantity,
      })) ?? []
    );
  }, [qtyInMasterpackBarcodes]);

  const regularPrint = useReactToPrint({
    content: () => printContentRef,
  });

  const getCurrentModel = ()=>cameraModels?.find(opt => opt.name === currentModel?.value);

  useEffect(()=>{
    loadCamerasModels();
    featureSwitchApi.getFeatureSwitch("manufacturing-rfid").then((result)=>{
      setRfidFlag(result.data.value);
    });
    
  },[])

  useEffect(()=>{
    if(currentMasterpack?.items) {
      if(Array.isArray(currentMasterpack?.items[0]))
        setTableData(setRedRows(currentMasterpack?.items[0]) ?? []);
      else
        setTableData(setRedRows(currentMasterpack?.items) ?? []);
      if(getMasterpackLiveQuantity() >= currentQtyInMasterpack?.value)
      {
        setShowPrintLabel(true);
        setMasterpackFull(true);
      }
      else
        setMasterpackFull(false);
    }
    else
      setTableData([]);

    function setRedRows(items){
      return items.map((item) => ({
        ...item,
        status: (item.cameraModel !== currentMasterpack.cameraModel.name ? "error": "")
      }));
    }
     
  },[currentMasterpack]);

  useEffect(()=>{
    const cameraModel = cameraModels?.find(opt => opt.name === currentModel?.value)
    console.log("___", cameraModel);
    if(cameraModel){
      setQtyInMasterpackBarcodes(cameraModel.barcodeByMasterpack);
      setRfidActive(cameraModel.isRFID && rfidFlag);
    }
      
    setCurrentQtyInMasterpack(undefined);
  },[currentModel]);

  useEffect(() => {
    if(currentMasterpack.barcode){
      console.log("pack", currentMasterpack);
      console.log("opt", qtyInMasterpackOptions)
      setCurrentQtyInMasterpack(qtyInMasterpackOptions.find(opt => opt.value === currentMasterpack.quantityInPack))
    }
  }, [qtyInMasterpackOptions])

  useEffect(() => {
    if(!scannerValue && scannerValue !== "")
    {
      setScannerError("");
      return;
    }
  },[scannerValue])
  
  useEffect(()=>{
    
    if(showPrintLabel){
      console.log("Print label");
      htmlLabelToBlobImage(printContentRef).then((blobImage)=>{
        const formData = new FormData();
        formData.append("file", blobImage, "label.png");
        formData.append("epc",currentMasterpack.rfidEpc);

        //downloadBlob(blobImage);
        if(rfidActive)
        {
          postPrintStandardZebraUsb(formData, (err, result)=>{
            console.log(result);
            if(err){
              appContext.showMessage(t('error'), "Masterpack print failed.");
            }
          });
        }
        else {
          regularPrint();
        }

        setShowPrintLabel(false);
      });
    }
  },[showPrintLabel])

  useEffect(()=>{
    //When lenght of pending twinpack reaches length of pack, throw it in the twinPack list for later processing, and clear the pending
    if(currentModel){
      console.log("PENDING GROOOWS", pendingTwinPack,pendingTwinPack.length, parseInt(getCurrentModel().numberByPack), "THE STAAAACKS", twinPacks)
      if(pendingTwinPack.length >= parseInt(getCurrentModel().numberByPack)){
        setTwinPacks((current)=> [...current, {
          twinSerialNumber:"",
          cameras:[...pendingTwinPack],
        }]);
        setPendingTwinPacks([]);
      }
    }
  },[pendingTwinPack])

  useEffect(()=>{
    if(currentModel){
      if((getMasterpackLiveQuantity()) === twinPacks.length && masterpackFull && twinPacks[0].twinSerialNumber === '' && twinAssociateAllowed){
        //Foreach twinpack, send the create, and replace the thing, maybe use a map!!! and then reset the array btiches
        setTwinAssociationAllowed(false);
        saveTwinPacks();
      }
    }
    //When lenght of pending twinpack reaches length of pack, throw it in the twinPack list for later processing, and clear the pending
    console.log("TWIN CHANGE", twinPacks, masterpackFull)
  },[twinPacks, masterpackFull])

  function manualPrint(){
    setShowPrintLabel(true);
  }

  async function saveTwinPacks() {
    setTwinAssociationAllowed(false);
    const newTwinArray = await Promise.all(
      twinPacks.map(async (twin) => {

        const result = await twinPackApi.newTwinPack(twin.cameras);
        console.log("RESUUUULT",result.data);
        twin.twinSerialNumber = result.data.twinSerialNumber;
        return twin;
      })
    );
  
    console.log("SAVED TWWWWWWWWWIIIN", newTwinArray)
    setTwinPacks(newTwinArray)
  }

  function loadMasterpack(e) {
    setIsLoadedMasterpack(true);
    setTwinAssociationAllowed(false);

    var { value } = e
    if (!value) {
      value = e
    }
    masterpackApi.getMasterpackSN(value)
      .then(res => {
       
        setCurrentMasterpack(res.data)
        setCurrentModel(cameraModelsOption.find(opt => opt.value === res.data.cameraModel.name));

        const items = res.data.items;
        const twinPacks = Object.values(
          items.reduce((acc, item) => {
            const key = item.twinPackSerialNumber;

            if (!acc[key]) {
              acc[key] = {
                twinSerialNumber: key,
                cameras: []
              };
            }

            acc[key].cameras.push(item.serialNumber);
            return acc;
          }, {})
        );
        setTwinPacks(twinPacks);
      })
      .catch(err => {
        // const error = err.response.data.error;
        // e.select();
        // this.setState({ errors: { general: error } })
      });
  }

  function createMasterpack() {
    setIsLoadedMasterpack(false);
    const cameraModel = getCurrentModel();
    masterpackApi
        .bulkInsertMasterpack(
          currentModel.value,
          1,
          currentQtyInMasterpack.value,
          cameraModel.barcodeByMasterpack?.find(opt => opt.masterpackQuantity === currentQtyInMasterpack.value).barcode
        )
        .then((res) => {
          try {
           setTwinPacks([])
           setCurrentMasterpack(res.data.masterpack[0]);
           
           if(cameraModel.isPack){
            setTwinAssociationAllowed(true);
           }
          } catch (e) {
            console.log(e);
          }
        }) // re-direct to login on successful register
        .catch((err) => {
          const errors = err.response ? err.response.data : err;
          //TODO POP ERROR MODAL
          appContext.showMessage(t('error'),errors)
          console.log(err);
        });
  }

  function loadCamerasModels() {
    cameraModelApi
      .getCameraModels()
      .then((res) => {
        let models = res.data;
        models.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        setCameraModels(models);
      });
  };

  function scannerOnKeyDown(e){
    //TODO If masterpack loaded
    //  check for camera scan
    if (e.key !== 'Enter')
      return;

    setScannerError("")
    if(!scannerValue)
      return;

    if(isValidMasterpackBarcode(scannerValue)){
      console.log("try load mastperack")
      loadMasterpack(scannerValue);
      setScannerValue("");
    }
    else {
      let error =undefined;
      const serialNumber = scannerValue.split(/,|;/)[0];
      if (!currentMasterpack.barcode) {
        error = "Please select a valid master pack first";
        //TODO Pop error modal
      }
      else if (currentMasterpack.items?.find(i => i.serialNumber === serialNumber)) {
        error = `Serial number ${scannerValue} already exists in this MasterPack`;
      }

      const model = getCurrentModel();
      if(!model.isPack && tableData.length >= currentQtyInMasterpack?.value)
        error="Masterpack full";
      else if(model.isPack && tableData.length/model.numberByPack >= currentQtyInMasterpack?.value)
        error="Masterpack full";

      setScannerValue("");
      if(error){
        setScannerError(error)
        //appContext.showMessage(t('error'), error);
        return;
      }
      
      checksumMasterpack(serialNumber);
      registerCameraToMasterpack(serialNumber);
    }

  }

  function checksumMasterpack (serialNumber) {
    cameraApi.getCamera(serialNumber)
      .then(res => {
        if (currentMasterpack.cameraModel.name !== res.data.cameraModel) {
          appContext.showMessage(t('warning'), t('attention_masterpack'));
          //TODO Log to NewRelic and maybe in local db as well
        }
      })
      .catch(err => {
        const error = err.response.data.error
        //appContext.showMessage(t('error'), error);
      });
  }

  function registerCameraToMasterpack(serialNumber){
    const shipping = Object.assign({}, {/*SHIPPING*/}, { errors: undefined });

    const data = {
      "barcode": currentMasterpack.barcode,
      "serialNumber": serialNumber,
      "shipping": {/*SHIPPING*/}
    }

    masterpackApi.newMasterpack(data)
      .then(res => {
        updateMasterpackItemsList(res.data.items);
        
        if(getCurrentModel().isPack)
          setPendingTwinPacks(prev => [...prev, serialNumber]);
          
      })
      .catch(err => {
        const error = err.response.data.error
        setScannerError(error)
        //appContext.showMessage(t('error'), error);
        //TODO Modal error
      });
  }

  const updateMasterpackItemsList = (items) => {
    setCurrentMasterpack(prev => ({
      ...prev,
      items: items
    }));
  };

  const removeFromMasterpackItemsList = (cameraSerialNo) => {
    setCurrentMasterpack(prev => ({
      ...prev,
      items: prev.items.filter(item => item.serialNumber !== cameraSerialNo)
    }));
  };

  const removeCameraFromMasterpack = (cameraSerialNo, checkTwin = true)=>{
    masterpackApi.removeItemFromMasterPack(currentMasterpack.barcode, cameraSerialNo);
    removeFromMasterpackItemsList(cameraSerialNo);
    if(checkTwin){
      const isPack = getCurrentModel().isPack;
      if(isPack){
        //Find any twin and also remove them.
        //check in twin and in pending
        
          // for (let i = 0; i < pendingTwinPack.length; i++) {
          //   const camera = pendingTwinPack[i];
          //   if(camera.serialNumber !== cameraSerialNo)
          //     removeCameraFromMasterpack(cameraSerialNo, false);
          // }

        removeFromTwinPack(cameraSerialNo);
          
        
        console.log('FIND ME SENPAAAAAAI',twinPacks)
      }
      
    }

    function removeFromTwinPack(cameraSerialNo) {
      console.log("DOO IT")
      setTwinPacks((prev) => {
        const pack = prev.find(p => p.cameras.includes(cameraSerialNo));
        console.log('removeFromTwinPack', pack)
        if (!pack) return prev;

        const camerasToRemove = pack.cameras; // e.g. ["3","4"]
        console.log('removeFromTwinPack', pack)
        camerasToRemove.forEach((cam) => {
          if(cam !== cameraSerialNo)
            removeCameraFromMasterpack(cam, false);
        });
        return prev.filter(p => p !== pack);
      });
    }
  }

  const getMasterpackLiveQuantity = (overrideMasterpackItems)=> {

    const items = overrideMasterpackItems ?? currentMasterpack?.items;

    //Consider isPack and Twinquantity
    if(!items)
      return 0;

    const model =getCurrentModel();
    let currentCnt = 0

    if(model?.isPack)
      currentCnt = items.length / model.numberByPack;
    else
      currentCnt = items?.length || 0;

    return parseInt(currentCnt);
  }

  const clearMasterpack = ()=>{
    
     appContext.showConfirmationMessage(t("warning"),t('newMasterpack.clear'), 
      async () => { 
        //Remove every masterpack, and clear the twin.
        for (let i = 0; i < currentMasterpack.items.length; i++) {
          const camera = currentMasterpack.items[i];
          removeCameraFromMasterpack(camera.serialNumber, false);
          // await masterpackApi.removeItemFromMasterPack(currentMasterpack.barcode, camera.serialNumber);
          // removeFromMasterpackItemsList(camera.serialNumber);
        }
        setTwinPacks([]);
        setPendingTwinPacks([]);
        //Clear pending
        //Clear twins
      },
      () => { console.log('Operation canceled!') })
  }


  const tableColumns =[
    {
      Header: t('dashboard_main.count'),
      accessor: (row, index)=>{
        return index + 1;
      },
    },
    {
      Header: t('dashboard_main.serialNumber'),
      accessor: "serialNumber",
    },
    {
      Header: t('dashboard_main.camera_model'),
      accessor: "cameraModel",
    },
    {
      Header: t('action'),
      accessor: (row, index)=>{
        return (
          <IconButton variant="contained" color="error" aria-label="delete" onClick={()=>{removeCameraFromMasterpack(row.serialNumber)}}>
            <DeleteIcon />
          </IconButton>
        );
      },
    }
  ]




  const TwinPackBox2 = ({twinName, cameras})=>{
     return <>
      <MuiCol size={2}>
          <MuiBox greyBox>
            {twinName}
            <hr/>
            {
              cameras?.length>0 ?
                cameras.map(camera => 
                  <>
                    {camera}
                    <br/>
                  </>
                )
              :
              <>
                {t("newMasterpack.empty")}
              </>
            }
          </MuiBox>
        </MuiCol>
     </>
  }

  return (
    <>
      <StandardPage
        title={t("dashboard_main.new_masterpack_titlev2")}
        description={t("newPallet.title_desc")}
        showPrinterStatus={false}
        showPrinterRFIDStatus={true}
      >
        <StandardPageTopContent>
          <MuiRow spacing={2}>
            <MuiCol size={{ xs: 12, md: 4 }}>
              <MuiSelect //disabled={tableData.length > 0}
                options={cameraModelsOption}
                placeholder={t("global.selectAModel")}
                value={cameraModelsOption.find(opt => opt.value === currentModel?.value) || null}
                onChange={setCurrentModel}
              />
            </MuiCol>
            <MuiCol size={{ xs: 12, md: 2 }}>
              <MuiSelect //disabled={tableData.length > 0}
                options={qtyInMasterpackOptions}
                placeholder={t("newMasterpack.selectQty")}
                value={qtyInMasterpackOptions.find(opt => opt.value === currentQtyInMasterpack?.value) || null}
                onChange={setCurrentQtyInMasterpack}
              />
            </MuiCol>
            <MuiCol size={{ md: 1 }}>
              <MuiButton large disabled={!(currentModel && currentQtyInMasterpack) && !currentMasterpack.barcode}
              onClick={createMasterpack}
              >{t('newMasterpack.create')}</MuiButton>
            </MuiCol>
            <MuiCol size={{ md: 1 }}>
              <MuiButton large disabled={!(isLoadedMasterpack || masterpackFull)}
              onClick={manualPrint}
              >{t('newMasterpack.print')}</MuiButton>
            </MuiCol>
          </MuiRow>
          {/* <MuiRow spacing={2}>
            <MuiCol size={{ xs: 12}}>
              <MuiTextArea sx={{ mt: 2}}
                  label={t("newPallet.specialRemark")}
                  value={specialRemark}
                  onChange={setSpecialRemark}
                />
              </MuiCol>
          </MuiRow> */}
          <MuiRow spacing={2}>
            <MuiCol size={{ xs: 12}}>
              <ScannerInput
                onChange={setScannerValue}
                onKeyDown={scannerOnKeyDown}
                value={scannerValue}
                label={t("newMasterpack.scanCameraOrMasterPack")}
                error={scannerError}
              />
            </MuiCol>
          </MuiRow>
          <MuiRow spacing={2}>
            { (getCurrentModel()?.isPack) ?  
              <>
                {
                  !(masterpackFull) && twinAssociateAllowed ? <TwinPackBox2 twinName="Pending TwinPack" cameras={pendingTwinPack} />:<></>
                }
                {
                  twinPacks.map(twin => {
                  const twinName =  twin.twinSerialNumber ? twin.twinSerialNumber: "Queued TwinPack";

                  return <TwinPackBox2 twinName={twinName} cameras={twin.cameras} />
                })}                 
              </>
              :
              <>
              </>
            }

          </MuiRow>
          <MuiRow spacing={2} sx={{ mb: 5, fontSize: '25px'}}>
            { !(currentMasterpack.barcode) ?  
              <MuiCol size={12}>{t("newMasterpack.noMasterpack")}</MuiCol> 
              :
              <>
                {/* <MuiCol>
                  <MuiButton sx={{ mt: 0}} large disabled={!currentMasterpack.barcode}>{t('reset')}</MuiButton>
                </MuiCol> */}
                <MuiCol>{t("newMasterpack.currentMasterPack",{ masterpackNo: currentMasterpack.barcode})}</MuiCol>
              </>
            }
          </MuiRow>
        </StandardPageTopContent>
        <StandardPageMainContent>
          <MuiRow sx={{ mb: 2}} justifyContent="flex-end">
            <MuiCol size={2} onClick={clearMasterpack}>
              <MuiButton disabled={isLoadedMasterpack} danger>{t('newMasterpack.clear')}</MuiButton>
            </MuiCol>

          </MuiRow>
          <ReactTableBuilder columns={tableColumns} data={tableData ?? []} maxRows={13}/>
        </StandardPageMainContent>
      </StandardPage>
      {
        showPrintLabel ? 
        <div className="center export-area" ref={el => (printContentRef = el)}>
          <MasterPackLabel key={0} mp={currentMasterpack} />
        </div>
        :
        <></>
      }
      
    </>
  );
}

NewMasterpackV2.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(NewMasterpackV2);